/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { hyphenate } from '../../utils/string';

const regularMonth = (date, cadence) => {
  const headerStyle = `day-header ${date.isSame(moment(), 'month') && 'today'}`;
  return (
    <div className="day-container">
      <div className={headerStyle}>{date.format('MMM').toUpperCase()}</div>
      <div className="day">
        <span>{date.month() + 1}</span>
        <br />
        <div className={cadence.status && hyphenate(cadence.status)}>
          {cadence.id ? `${cadence.short_name[0]}${cadence.id}` : ''}
        </div>
      </div>
    </div>
  );
};

const firstMonth = (date, cadence) => (
  <div className="first-day">
    <div className="month">
      <div>{date.format('YYYY')}</div>
    </div>
    {regularMonth(date, cadence)}
  </div>
);

const Month = ({ date, cadence }) => {
  const month = date.month();
  return month === 0 ? firstMonth(date, cadence) : regularMonth(date, cadence);
};

Month.propTypes = {
  date: PropTypes.object,
  cadence: PropTypes.object
};

export default Month;
